// Copyright 2026. WebPros International GmbH. All rights reserved.

export const ADMIN_ROUTE_PREFIX = '/admin';
